import React from 'react';
import { useDispatch } from 'react-redux';
import { useFlightProvider } from '@src/features/order/provider';
import { ArcDroneMarker, setMapCenter } from '@src/core/controllers';
import { FlightDroneProps } from './types';

const FlightDrone: React.FC<FlightDroneProps> = (props) => {
  const { drone } = props;
  const dispatch = useDispatch();
  const { flightData } = useFlightProvider();

  const droneLat = Number(drone?.latitude);
  const droneLng = Number(drone?.longitude);

  const flightLat = Number(flightData?.latitude);
  const flightLng = Number(flightData?.longitude);

  React.useEffect(() => {
    if (isNaN(droneLat) || isNaN(droneLng)) return;
    dispatch(setMapCenter({ lat: droneLat, lng: droneLng }));
  }, [droneLat, droneLng, dispatch]);

  return (
    <ArcDroneMarker.idle 
      position={{ 
        lat: isNaN(flightLat) ? droneLat : flightLat, 
        lng: isNaN(flightLng) ? droneLng : flightLng,
      }} 
    />
  );
};

export default FlightDrone;